import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const buttonStyle = css`
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(1)};
  box-shadow: ${theme.shadows.light};
  top: -${theme.spacing(0.8)};
  border-radius: ${theme.borderRadius.small};
  &:hover {
    background-color: ${theme.colors.white};
  }
`;

export const buttonContainerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;
